/* eslint-disable react-hooks/exhaustive-deps */
import * as React from 'react';


import {
  Box,
} from '@mui/material';

import Header from '../../components/layout/header';
import { Middle } from '../../components/layout/middle';
import { BaseDiv } from './styles';
import { Footer } from '../../components/layout/footer';



const Home: React.FC = () => {

  const ref: any = React.useRef(null);
  const refmid = React.useRef(null);
  const [dadosRef, setDadosRef] = React.useState<React.RefObject<HTMLDivElement>>(React.createRef<HTMLDivElement>());
  const [refTitle, setRefTitle] = React.useState(null);

  React.useEffect(() => {
    const handleResize = () => {
      setDadosRef(ref.current);
      setRefTitle(ref?.current?.title)
    };

    window.addEventListener('resize', handleResize);

    handleResize();

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [dadosRef, ref]);

  return (
    <BaseDiv>
      <Box>
          <Box>
            <Header reference={dadosRef} title={refTitle}/>
            <div ref={refmid}>
              <Middle/>
            </div>
          </Box>
          <Box>
            <Footer />
          </Box>
        </Box>
    </BaseDiv>
  );
}

export { Home }